import { queryOptions, useQuery } from '@tanstack/react-query'
import { getFarm, type User } from '@/services/farmMapping/getFarms'
import { queryKeys } from './queryKeys'

// Callers that reload the farm from an imperative callback, where a hook cannot run, take these
// options to fetchQuery so that read lands on the same cache entry every declarative reader uses.
export const farmQueryOptions = ({ farmId, user }: { farmId: string; user: User }) =>
  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- the user only scopes the request by its session-constant hubId claim (see queryKeys.farms)
  queryOptions({
    queryKey: queryKeys.farm(farmId),
    queryFn: ({ signal }) => getFarm({ id: farmId, user, signal }),
  })

export const useFarm = (farmId: string | undefined, user: User | undefined) =>
  useQuery({
    ...farmQueryOptions({ farmId: farmId as string, user: user as User }),
    enabled: !!farmId && !!user,
  })
